import React from "react"
import { graphql, Link, PageProps } from "gatsby"

import { Layout } from "@interia/common/components/layout"
import { Seo } from '../components/seo'
import useMainMenu from "../hooks/useMainMenu"
import { Section } from "@interia/common/components/section"
import styled from "styled-components"
import { H1, P } from "@interia/common/components/typography"
import { StaticImage } from "gatsby-plugin-image"
import { palette } from "@interia/common/styles/global"
import { ContainedButton } from "@interia/common/components/buttons"
import { ClearLink } from "@interia/common/components/header/menuItem.style"
import useFooter from "../hooks/useFooter"

type DataProps = {
  site: {
    siteMetadata: {
      title: string
    }
  }
}


const NotFoundPage = ({ data: { site } }: PageProps<DataProps>) => {
  const siteTitle = site.siteMetadata.title
  const menuItems = useMainMenu()
  const footer = useFooter()

  return (
    <Layout footer={footer} gemiusId='0nKacee.fzah6lJ8915YdYZR7FlRDyyXVPlG5jJtFhH.P7' logoUrl={{ external: false, url: '/' }} menuItems={menuItems}>
      <Wrapper>
        <Background>
          <StaticImage
            style={{ height: '100%', width: '100%', maxHeight: '100%' }}
            src="../../../../static/mission-background.png"
            placeholder="blurred"
            formats={["auto", "webp"]}
            alt=""
            title=""
            quality={100}
          />
        </Background>
        <Title>
          Strona nie została znaleziona
        </Title>
        <Description>
          Podany adres jest niepoprawny  lub strona została usunięta
        </Description>
        <ClearLink to={process.env.APP_URL ?? '/'}>
          <BackButton theme="#F60B46">
            Wróć do strony głównej
          </BackButton>
        </ClearLink>
      </Wrapper>
    </Layout>
  )
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Wrapper = styled(Section)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${palette.white};
  min-height: 50vh;
`

const Title = styled(H1)`
  margin:1rem;
  font-size: 3.75rem;
  font-weight: 500;
  margin-bottom:0.5rem;
  text-align:center;
`

const Description = styled(P)`
  margin:1rem;
  text-align: center;
`


const Background = styled.div`
 position: absolute;
 z-index: -3;
 top:0;
 left:0;
 height:100%;
 width: 100%;
`

const BackButton = styled(ContainedButton)`
  margin-top: 2rem;
  font-size: 1.25rem;
`